var _style, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _rect, _polygon9, _polygon10, _polygon11, _path, _polygon12, _polygon13, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 92.7 25.7",
    style: {
      enableBackground: "new 0 0 92.7 25.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,0.9 10.9,25.7 0,25.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11,0 11,22 1.3,0 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "22.6,0 12.6,22.2 12.6,0 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "23.6,1.7 23.6,25.7 12.7,25.7 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "32.4,16.7 35.1,16.7 35.1,24.1 36.5,24.1 36.5,16.7 39.3,16.7 39.3,15.2 32.4,15.2 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "42.8,24.1 49.2,24.1 49.2,22.6 44.2,22.6 44.2,20.4 47.8,20.4 47.8,18.9 44.2,18.9 44.2,16.7  49.2,16.7 49.2,15.2 42.8,15.2 "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "59.5,15.2 57.7,15.2 55.6,18.2 53.5,15.2 51.7,15.2 54.7,19.5 51.5,24.1 53.3,24.1 55.6,20.8  57.9,24.1 59.7,24.1 56.5,19.5 "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "61.5,16.7 64.3,16.7 64.3,24.1 65.8,24.1 65.8,16.7 68.5,16.7 68.5,15.2 61.5,15.2 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 71.8,
    y: 15.2,
    className: "st0",
    width: 1.5,
    height: 8.9
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "78.8,15.2 77.4,15.2 77.4,24.1 82.8,24.1 82.8,22.6 78.8,22.6 "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "92.7,16.7 92.7,15.2 86.3,15.2 86.3,24.1 92.7,24.1 92.7,22.6 87.8,22.6 87.8,20.4 91.4,20.4  91.4,18.9 87.8,18.9 87.8,16.7 "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "39.3,1.6 36.4,8 33.8,2.1 33.6,1.6 32.4,1.6 32.4,10.5 33.8,10.5 33.8,5.8 35.8,10.1 36,10.5  36.9,10.5 39,5.8 39,10.5 40.5,10.5 40.5,1.6 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M56.4,6.8h2.7c-0.1,0.5-0.3,1-0.7,1.4c-0.5,0.6-1.1,0.8-1.8,0.8c-0.7,0-1.3-0.3-1.8-1c-0.4-0.6-0.7-1.2-0.7-2 c0-0.9,0.3-1.6,0.8-2.2c0.5-0.5,1-0.8,1.7-0.8c0.6,0,1.2,0.2,1.6,0.6c0.2,0.2,0.3,0.3,0.4,0.5l0.1,0.2l1.3-0.7L60,3.6 c-0.3-0.6-0.9-1.1-1.6-1.5c-0.6-0.3-1.2-0.4-1.8-0.4c-1,0-2,0.4-2.8,1.2c-0.8,0.9-1.2,2-1.2,3.2c0,1.2,0.4,2.3,1.2,3.2 c0.8,0.8,1.7,1.2,2.8,1.2c1,0,2-0.4,2.7-1.2c0.8-0.9,1.2-1.9,1.2-3.2V5.3h-4.2L56.4,6.8L56.4,6.8z"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "68.2,2.1 68,1.6 67,1.6 63.6,9.5 63.2,10.5 64.8,10.5 67.5,4.2 70,10.1 70.2,10.5 71.8,10.5 "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "80.1,10.5 81.6,10.5 81.6,1.6 80.1,1.6 80.1,5.3 76.4,5.3 76.4,1.6 74.9,1.6 74.9,10.5 76.4,10.5  76.4,6.8 80.1,6.8 "
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 5.3,
    className: "st0",
    width: 3.8,
    height: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 9.1,
    className: "st0",
    width: 5.1,
    height: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 1.6,
    className: "st0",
    width: 5.1,
    height: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.09b607021598f2cdab8029abb55d95ec.svg";
export { ForwardRef as ReactComponent };